/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_PUBLIC, API_SERVER } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { Link } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Module]
-------------------------------------------------------------------*/
import LinesEllipsis from 'react-lines-ellipsis'
import { decode } from "html-entities";
/*------------------------------------------------------------------
[End React Module]
-------------------------------------------------------------------*/



const Screen = ({loading, error}) => {

    const [data, set_data] = useState(null);

    const [pagination_active, set_pagination_active] = useState(1);

    const _read = (pages) => {

        let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (8 * pages) - 8 : 0
        
        }
        
        loading(true);

        API_GET_PUBLIC(`client/post_news__________?limit=8&offset=${offsetSync}`)
        .then((response) => {
            if(response.data.result === 'success'){
                loading(false)
                set_data(response.data.data)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

    }
    
    useEffect(() => {
        
		_read()

    }, [])

	return (
		<>
            <div className="_container">
                <div className="_lily_pad_h_d __section_pages_title">
                    <h1>Berita</h1>
                </div>
            </div>
            <div className="_container">
				<div className="_push_t_g">
					<div className="_row_sync">
						{
                            data ? 
                                data.post.map((item, index) => (
                                    <Link to={'post/' + item.slug} className="_column_sync">
                                        <div className="__card" style={{backgroundImage: `url(${item.preview})`}}>

                                        </div>
                                        <div className="_push_t_m">
                                            <div className="_row _center_align">
                                                <div className="_push_r_s">
                                                    <ion-icon name="time-outline" style={{fontSize: 18, marginBottom: -4}}></ion-icon>
                                                </div>
                                                <div className="_column">
                                                    <small>Publised, {item.date}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <LinesEllipsis
                                            style={{marginTop: 6}}
                                            text={decode(item.title)}
                                            maxLine='2'
                                            ellipsis='...'
                                            trimRight
                                            basedOn='letters'
                                        />
                                    </Link>
                                ))
                            : 
                                <>
                                    <div className="_column_sync">
                                        <div className="__card"/>
                                    </div>
                                    <div className="_column_sync">
                                        <div className="__card"/>
                                    </div>
                                    <div className="_column_sync">
                                        <div className="__card"/>
                                    </div>
                                    <div className="_column_sync">
                                        <div className="__card"/>
                                    </div>
                                </>
						}
					</div>
				</div>
			</div>
            <div className="_container">
                <div className="_lily_pad_h_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div>
            </div>
        </>
	);
}

export default Screen;